import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useTranslation } from "react-i18next";
import { TemplateCategory } from "../../../../enums/TemplateCategory";

const FILTER_OPTIONS = [
  "ALL",
  "NO_CATEGORY",
  ...Object.values(TemplateCategory),
];

export default function TemplateCategoryFilter({
  value = "ALL",
  onChange,
  size = "small",
  fullWidth = true,
}) {
  const { t } = useTranslation();

  return (
    <FormControl fullWidth={fullWidth} size={size}>
      <InputLabel>{t("Category")}</InputLabel>
      <Select value={value} onChange={onChange} label={t("Category")}>
        {FILTER_OPTIONS.map((opt) => (
          <MenuItem key={opt} value={opt}>
            {t(opt)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
